import { GeocodingService } from './../../utils/geocoding.service';
import { DataManagementService } from './../../providers/data-management.service';
import { MapService } from './../../utils/map.service';
import { PointInterest } from './../../objects/data-management';
import { Component,Input, Output } from '@angular/core';
import * as L from 'leaflet';
import { NavController, NavParams, ModalController,AlertController,LoadingController,ViewController,ToastController } from 'ionic-angular';
import Polygon = L.Polygon;
import Marker = L.Marker;
import Icon = L.Icon;
import {GlobalService} from "../../providers/global.config";

 @Component({
    selector: 'app-poi',
    templateUrl: 'poi.html'
})

export class Poi{
    imagesDir = this.globalService.getimagesDir();
    imagesPOIDir = this.globalService.getimagesPOIDir();
    pointInterests: PointInterest[] = [];
    pointInterestsPoint: PointInterest[] = [];
    pointInterestsPolygon: PointInterest[] = [];
    images = [
        {text: "marker1", uri: this.imagesDir+ this.imagesPOIDir+ "marker1.png"},
        {text: "marker2", uri: this.imagesDir +this.imagesPOIDir+ "marker2.png"},
        {text: "marker3", uri: this.imagesDir +this.imagesPOIDir+  "marker3.png"},
        {text: "marker4", uri: this.imagesDir +this.imagesPOIDir+  "marker4.png"},
        {text: "marker5", uri: this.imagesDir +this.imagesPOIDir+ "marker5.png"},
        {text: "marker6", uri: this.imagesDir +this.imagesPOIDir+ "marker6.png"},
        {text: "marker7", uri: this.imagesDir +this.imagesPOIDir+ "marker7.png"},
        {text: "marker8", uri: this.imagesDir +this.imagesPOIDir+ "marker8.png"},
        {text: "marker9", uri: this.imagesDir + this.imagesPOIDir+"marker9.png"},
        {text: "marker10", uri: this.imagesDir +this.imagesPOIDir+ "marker10.png"},
        {text: "marker11", uri: this.imagesDir +this.imagesPOIDir+ "marker11.png"},
        {text: "flag1", uri: this.imagesDir +this.imagesPOIDir+ "flag1.png"},
        {text: "flag2", uri: this.imagesDir + this.imagesPOIDir+"flag2.png"},
        {text: "house1", uri: this.imagesDir +this.imagesPOIDir+ "house1.png"},
        {text: "house2", uri: this.imagesDir + "house.png"}
    ];
    pointinterest:PointInterest=new PointInterest();
    selectedImage: { text: string, uri: string } = this.images[0];
    addresspoi:string;
    latpoi:number;
    lngpoi:number;
    imageuripoi:any;
    name;
    constructor(public navParams: NavParams,private toastCtrl:ToastController,private mapService: MapService,private alertCtrl: AlertController,
        public toastr: ToastController,private dataManagementService: DataManagementService, public viewCtrl: ViewController,
        private geocodingService: GeocodingService,private globalService : GlobalService) {
        this.pointinterest = navParams.get('pointInterest');
        this.name=this.pointinterest.name;
    }
    //fermer modal with point d'interet non null
    closeModal(){
        
        this.viewCtrl.dismiss({pointinterest:this.pointinterest});
    }

    //ajouter poi
    addpoi(){
        if(this.pointinterest.name==null){
            let alert = this.alertCtrl.create({
                title: 'Alert',
                subTitle: 'Ajouter un Nom',
                buttons: ['Ok']
            });
            alert.present();
        }else{
        this.pointinterest.type='MARKER';
        this.selectedImage.uri=this.imagesPOIDir+this.selectedImage.text;
        console.log(this.selectedImage)
        this.pointinterest.imageUri=this.selectedImage.uri;
        this.dataManagementService.addPointInterest(this.pointinterest).subscribe(pointInterest => {
             this.dataManagementService.pointInterests.push(pointInterest);

        })
        this.viewCtrl.dismiss({pointinterest:this.pointinterest });
        }
    }
    edit(){
        this.dataManagementService.updatePointInterest(this.pointinterest).subscribe((updated) => {
            if (updated) {
             this.viewCtrl.dismiss(this.pointinterest);
             let toast = this.toastCtrl.create({
                message: ''+this.pointinterest.name+' est modifié avec succés',
                duration: 3000,
                position: 'top'
              });
            
              toast.present();

            } else {
               
            }
        }, () => {
      
        })
    }
   
}


// WEBPACK FOOTER //
// ./src/pages/poi/poi.ts